import { render } from "./MunicipioUfPerfilDados.vue?vue&type=template&id=253552b9&ts=true"
import script from "./MunicipioUfPerfilDados.vue?vue&type=script&lang=ts"
export * from "./MunicipioUfPerfilDados.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__